import { render, staticRenderFns } from "./TransactionExtensionFieldNameModal.vue?vue&type=template&id=402db4d9"
import script from "./TransactionExtensionFieldNameModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionExtensionFieldNameModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402db4d9')) {
      api.createRecord('402db4d9', component.options)
    } else {
      api.reload('402db4d9', component.options)
    }
    module.hot.accept("./TransactionExtensionFieldNameModal.vue?vue&type=template&id=402db4d9", function () {
      api.rerender('402db4d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/TransactionExtensionFieldNameModal.vue"
export default component.exports